import {useQuery} from '@tanstack/react-query'

import {getMenuItemList} from '@/lib/food-grubhub/foodGrubhubService'
import type {MenuItemListingQuery} from '@/lib/food-grubhub/foodRestaurantDetailModel'

const useMenuItemListing = (params: MenuItemListingQuery, token: string) => {
  return useQuery({
    queryKey: ['menu_item_listing', params, token],
    queryFn: async () =>
      getMenuItemList({
        time: params.time,
        location: params.location,
        operationId: params.operationId,
        isFutureOrder: params.isFutureOrder,
        restaurantStatus: params.restaurantStatus,
        brandUuid: params.brandUuid,
        isNonRestaurantMerchant: params.isNonRestaurantMerchant,
        merchantTypes: params.merchantTypes,
        orderType: params.orderType,
        pageSize: params.pageSize,
        agent: params.agent,
        weightedItemDataIncluded: params.weightedItemDataIncluded,
        task: params.task,
        rpcVariant: params.rpcVariant,
        platform: params.platform,
        restaurantId: params.restaurantId,
        menuItemId: params.menuItemId,
        token,
        signal: undefined,
      }),
    enabled: Boolean(token && params.restaurantId && params.menuItemId),
    placeholderData: keepPreviousData,
  })
}

export default useMenuItemListing
